import { UAT_MODE } from "../../Model/Network/Api/config";
import {FirebaseUtils} from "../../Utils/Firebase";
import _ from "lodash";

const Home = [
    {
        cname: 'organisation',
        value: 'Organisation',
        ukey: '2',
        path: '/app/organisation',
        info: 'Manage company hierarchy',
        link: "/app/organisation/offices",
        minfo: 'Hierarchy',
        filter: data => {
            return true
        }
    },
    {
        cname: 'policies',
        badge: 'policies',
        value: 'Control Room',
        ukey: '9',
        path: '/app/tower',
        link: "/app/tower",
        info: 'Manage company programmes',
        role: ["management.read"],
        color: "#1C2D41",
        module: "PROGRAMMES",
        isSuper : true,
        filter: data => {
            return data.main;
        }
    },
    {
        cname: 'approvals',
        value: 'Approvals',
        ukey: '9',
        path: '/app/approvals',
        link: "/app/approvals",
        info: 'View all approvals',
        role: ["finance.read"],
        filter: data => {
            return data.main;
        }
    },
]


const Main = [
    {
        cname: "expenses",
        value: "Expenses",
        ukey: '18',
        path: '/app/expenses',
        link: '/app/expenses',
        info: "All Expense history of your company",
        role: ["finance.read"],
        filter: data => {
            return data.main || data.finance;
        }
    },
    {
        cname: 'advance',
        value: 'Advances',
        ukey: '15',
        path: '/app/advances/petty',
        link: "/app/advances/petty",
        info: 'Petty Cash Management',
        role: ["finance.write"],
        badge: 'petty',
        color: "#FF7C51",
        module: "ADVANCES",
        filter: data => {
            return data.main || data.finance;
        }
    },
];


const Workspace = [
    {
        cname: 'townhall',
        value: 'Town Hall',
        ukey: 100,
        path: '/app/workspace/townhall',
        link: '/app/workspace/townhall',
        info: 'View Townhall',
        beta: true,
        module: 'TOWNHALL',
        filter: data => {
            return data.main
        }
    },
    {
        cname: 'fieldAssist',
        value: 'Field Assist',
        ukey: 100,
        path: '/app/workspace/assist',
        link: '/app/workspace/assist/plotter',
        info: 'View Field',
        beta: true,
        module: 'FIELDASSIST',
        filter: data => {
            return data.main
        }
    },
    {
        cname: 'flow',
        value: "Custom Workflow",
        ukey: 100,
        path: '/app/workspace/workflow',
        link: '/app/workspace/workflow',
        info: "View Filters",
        module: "CUSTOMWORKFLOW",
        filter: data => {
            return data.main
        }
    }, {
        cname: 'support',
        value: "Custom Support",
        ukey: 100,
        path: '/app/workspace/support',
        link: '/app/workspace/support',
        info: "View Filters",
        module: "CUSTOMSUPPORT",
        filter: data => {
            return data.main
        }
    }, {
        cname: 'excel',
        value: "Custom Excel",
        ukey: 100,
        path: '/app/workspace/excel',
        link: '/app/workspace/excel',
        info: "View Filters",
        module: "CUSTOMEXCEL",
        filter: data => {
            return data.main
        }
    }, {
        cname: 'app',
        value: "Workflow Builder",
        ukey: 100,
        path: '/app/workspace/app',
        link: '/app/workspace/app',
        info: "View Filters",
        module: "CUSTOMAPP",
        filter: data => {
            return data.main
        }
    }, {
        cname: 'form',
        value: "Custom Forms",
        ukey: 100,
        path: '/app/workspace/forms',
        link: '/app/workspace/forms',
        info: "View Filters",
        module: "CUSTOMSURVEY",
        filter: data => {
            return data.main
        }
    },
    {
        cname: 'scanner',
        value: 'Masters',
        ukey: 110,
        path: '/app/workspace/table',
        link: '/app/workspace/table',
        info: 'Custom Table',
        module: 'CUSTOMTABLE',
        filter: data => {
            return data.main
        }
    },
    {
        cname: 'scanner',
        value: 'Scanner Rooms',
        ukey: '15',
        path: '/app/vendor/scanners',
        link: "/app/vendor/scanners",
        info: 'Manage your Account Settings',
        module: "VENDOR",
        filter: data => {
            return data.main
        }
    },
    {
        cname: 'app',
        value: 'Third Party Apps',
        ukey: '15',
        path: '/app/apps',
        link: "/app/apps",
        info: 'Third Party Apps',
        module: "VENDOR",
        filter: data => {
            return data.main
        }
    },
    {
        cname: 'seekClarification',
        value: 'Seek Clarification',
        ukey: '15',
        path: '/app/workspace/seekclarification',
        link: "/app/workspace/seekclarification",
        info: 'Seek Clarification',
        module: UAT_MODE ? "Seek Clarification" : undefined,
        filter: (data,config) => {
            return (['INCRED','INCRD'].includes(config.tenant) && !config.isSuper) ? (data.main && config.modules.includes("Seek Clarification")) : data.main
        }
    }
]


const Others = [
    {
        cname: 'export',
        value: 'Export Wizard',
        ukey: '13',
        path: '/app/others/export',
        link: "/app/others/export/expense/export",
        info: 'Export expense report',
        module: UAT_MODE ? "Export Wizard" : undefined,
        role: ["finance.read"],
        filter: (data,config) => {
            return (['INCRED','INCRD'].includes(config.tenant) && !config.isSuper) ? (data.main && config.modules.includes("Export Wizard")) : data.main
        }
    },
    {
        cname: 'reports',
        value: 'Reports',
        ukey: '14',
        path: '/app/others/reports',
        link: "/app/others/reports",
        info: 'Report',
        role: ["finance.read"],
        filter: data => {
            return data.main
        }
    },
    {
        cname: 'auditLogs',
        value: 'AuditLogs',
        ukey: '14',
        path: '/app/others/auditLogs',
        link: "/app/others/auditLogs",
        info: 'Report',
        role: ["finance.read"],
        filter: (data, config) => {
            return data.main && (config.isSuper || (config.plugins.auditLogging && config.modules.includes("AUDIT_LOGS")))
        }
    }
]


const SETTLEMENTS = [
    {
        cname: 'voucher',
        value: 'Expense Vouchers',
        ukey: '12',
        badge: 'voucher',
        color: "#212121",
        path: '/app/others/settlements/offline',
        link: "/app/others/settlements/offline",
        info: 'Manage your settlements',
        module: "SETTLEMENTS",
        filter: (data,config) => {
            let isVendor = _.includes(config.modules, "SETTLEMENTS");
            return (data.main || data.finance) && isVendor;
        }
    },
    {
        cname: 'payables',
        value: 'Account Payables',
        ukey: '12',
        badge: 'invoice',
        color: "#212121",
        path: '/app/others/settlements/invoicing',
        link: "/app/others/settlements/invoicing",
        info: 'Manage your settlements',
        module: "VENDOR SETTLEMENTS",
        filter: (data,config)  => {
            let isVendor = _.includes(config.modules, "VENDOR");
            if (isVendor) {
                isVendor = _.includes(config.modules, "VENDOR SETTLEMENTS")
            }
            return ( data.main || data.finance) && isVendor
        }
    },
    {
        cname: 'travel',
        value: 'Travel Bookings',
        ukey: '12',
        color: "#212121",
        path: '/app/others/settlements/bookings',
        link: "/app/others/settlements/bookings",
        info: 'Manage your settlements',
        module: "SETTLEMENTS",
        filter: (data,config) => {
            let isVendor = _.includes(config.modules, "SETTLEMENTS");
            if(isVendor){
                isVendor = _.includes(config.modules, "SELF BOOKINGS");
            }
            return (data.main || data.finance) && isVendor;
        }
    },
    {
        cname: 'settlement',
        value: 'Employee Settlements',
        ukey: '12',
        color: "#212121",
        path: '/app/others/settlements/employees',
        link: "/app/others/settlements/employees",
        info: 'Manage your settlements',
        module: "SETTLEMENTS",
        filter: (data,config)  => {
            let isVendor = _.includes(config.modules, "SETTLEMENTS");
            return (data.main || data.finance) && isVendor;
        }
    },
    {
        cname: 'settlement',
        value: 'Vendor Settlements',
        ukey: '12',
        color: "#212121",
        path: '/app/others/settlements/vendor',
        link: "/app/others/settlements/vendor",
        info: 'Manage your settlements',
        module: "SETTLEMENTS",
        filter: (data,config)  => {
            let isVendor = _.includes(config.modules, "VENDOR");
            if (isVendor) {
                isVendor = _.includes(config.modules, "VENDOR SETTLEMENTS")
            }
            return ( data.main || data.finance) && isVendor
        }
    }
]

const Payments = [

    {
        cname: 'payout',
        value: 'Payouts',
        ukey: '16',
        path: '/app/others/payouts',
        link: "/app/others/payouts/active",
        info: 'Payments using wallet',
        role: ["payouts.read"],
        badge: "payouts",
        color: "#00C853",
        filter: data => {
            return data.main || data.finance
        }
    },
    {
        cname: 'qr',
        value: 'Qr Payments',
        ukey: '16',
        path: '/app/others/qr',
        link: "/app/others/qr",
        info: 'Payments using wallet',
        color: "#00C853",
        module: "QR",
        filter: data => {
            return data.main || data.finance
        }
    },

    {
        cname: 'invoice',
        value: 'Tds Payments',
        ukey: '16',
        path: '/app/others/tds',
        link: "/app/others/tds",
        info: 'Payments using wallet',
        color: "#00C853",
        filter: (data,config) => {
            return config.plugins.tdsPayments
        }
    },
    {
        cname: 'invoice',
        value: 'Gst Payments',
        ukey: '16',
        path: '/app/others/gst',
        link: "/app/others/gst",
        info: 'Payments using wallet',
        color: "#00C853",
        filter: (data,config) => {
            return config.plugins.gstinPayments
        }
    },
    {
        cname: 'invoice',
        value: 'Invoice Discounting',
        ukey: '16',
        path: '/app/others/discount',
        link: "/app/others/discount",
        info: 'Payments using wallet',
        color: "#00C853",
        filter: (data,config) => {
            return config.plugins.invoiceDiscountingV2
        }
    },
    {
        cname: 'utility',
        value: 'Utility Payments',
        ukey: '15',
        path: '/app/utility',
        link: "/app/utility/history",
        info: 'Manage your Account Settings',
         module: "UTILITYPAYMENTS",
        filter: data => {
            return data.main || data.finance
        }
    },
]

const Vendor = [
    {
        cname: 'vendor',
        value: 'Vendor Management',
        ukey: '2',
        path: '/app/vendor/contacts',
        info: 'Manage company hierarchy',
        link: "/app/vendor/contacts",
        filter: data => {
            return data.main || data.procure
        }
    },
    {
        cname: 'invoice',
        value: 'Invoice Management',
        ukey: '15',
        color: "#7551E9",
        path: '/app/vendor/invoices',
        link: "/app/vendor/invoices",
        info: 'Manage your Vendor Invoices',
        module: "VENDOR",
        filter: data => {
            return data.main || data.procure
        }
    },
    {
        cname: 'invoice',
        value: 'Onhold Payment',
        ukey: '15',
        color: "#7551E9",
        path: '/app/vendor/onholdPayment',
        link: "/app/vendor/onholdPayment",
        info: 'Manage your Vendor Onhold Payment',
        module: "GST ONHOLD PAYMENTS",
        filter: data => {
            return data.main || data.procure
        }
    },
    {
        cname: 'procure',
        value: 'Procurement',
        ukey: '15',
        badge: 'procurement',
        color: "var(--primary-color)",
        key:"procurement",
        path: '/app/vendor/procurement',
        link: "/app/vendor/procurement",
        info: 'Manage your Account Settings',
        module: "VENDORPR",
        filter: data => {
            return data.main || data.procure
        },
    },
    {
        cname: 'stock',
        value: 'Product & Stocks',
        ukey: '15',
        path: '/app/vendor/products',
        link: "/app/vendor/products",
        info: 'Manage your Account Settings',
        module: UAT_MODE ? "Product and Stocks" : "VENDOR",
        filter: (data,config) => {
            return (['INCRED','INCRD'].includes(config.tenant) && !config.isSuper) ? (data.main || data.procure) && config.modules.includes("Product and Stocks") : data.main || data.procure
        }
    },
    {
        cname: 'invoice',
        value: 'Contract Management',
        ukey: '15',
        color: "#7551E9",
        path: '/app/vendor/contracts',
        link: "/app/vendor/contracts",
        info: 'Manage your Vendor Invoices',
        module: "VENDOR",
        filter: data => {
            return data.main || data.procure
        }
    },
]

const Account = [
    {
        cname: 'settings',
        value: 'Account Settings',
        ukey: '15',
        path: '/app/settings',
        link: "/app/settings",
        info: 'Manage your Account Settings',
        filter: data => {
            return true
        }
    },
    {
        cname: 'logout',
        value: 'Logout',
        ukey: '16',
        path: '/app/logout',
        info: 'Sign off Securely',
        onClick: () => {
            window.localStorage.clear()
            FirebaseUtils.signout()
            window.location.replace('https://enterprise.dice.tech')

        },
        filter: data => {
            return true
        }
    }

]

export { Home, Main, Others, Payments, Account, Workspace, Vendor, SETTLEMENTS };
